import { render } from "./SetVideo.vue?vue&type=template&id=41a74054"
import script from "./SetVideo.vue?vue&type=script&lang=js"
export * from "./SetVideo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__